import { render, staticRenderFns } from "./AddressWrapper.vue?vue&type=template&id=69e0ba3f&"
import script from "./AddressWrapper.vue?vue&type=script&lang=js&"
export * from "./AddressWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports